import styles from "./Stellenangebote.module.css";
import unserteam from "./assets/karriere_foto.png";
import React from "react";


const Stellenangebote = () => {
    return(
        <>
            <div
                className={styles.hero}
                style={{ backgroundImage: `url(${unserteam})`}}
            ></div>


             {/*
             <main className="wrapper">
             <section className="wrapperContent">
                <div className={styles.text}>
                    <h1>Schulleitung gesucht – IGS mit Grundstufe</h1>
                    <p>Die <span style={{ fontWeight: "700" }}>IKS - Interkulturelle Schule Rhein/Main </span> sucht für ihre <span style={{ fontWeight: "700" }}>integrierte Gesamtschule (IGS)</span> mit Grundstufe <span style={{ fontWeight: "700" }}>eine Schulleiterin / einen Schulleiter</span> zur Leitung einer Ganztagsschule mit ca. 1000 Schülerinnen und Schülern.</p>
                    <p><span style={{ fontWeight: "700" }}>Voraussetzungen:</span></p>
                    <lu>
                        <li>1. und 2. Staatsexamen (Gymnasium oder H/R)</li>
                        <li>Unterrichtserfahrung in mehreren Bildungsgängen</li>
                        <li>Fächerkombination: Gesellschaftswissenschaften (Geschichte, Geografie und Politik und Wirtschaft) + Sprache (Deutsch, Englisch, Spanisch oder Latein)</li>
                        <li>Nachweisbare Leitungserfahrung (z.B. Schulentwicklung, Organisation, Fachbereichleitung)</li>
                    </lu>

                    <p>
                      <span style={{ fontWeight: "700" }}>Ende der Bewerbungsfrist: 30.05.2025</span> <br />
                      <span style={{ fontWeight: "700"}}>“Die Bewerbungsfrist wurde bis einschließlich 26.06.2025 verlängert.” </span> <br />
                      European School of Economics gGmbH <br/>
                      z. H. Herrn Dr. Ismail Özkan <br />
                      Kaiserkronenweg 1, 60433 Frankfurt am Main <br />
                      Link: <a href="/assets/karriere/SLStellenausschr IGS.pdf" download>zur der Ausschreibung</a> <br />
                      E-Mail: <a href="mailto:i.oezkan@ese-frankfurt.de">i.oezkan@ese-frankfurt.de</a>
                    </p>

                </div>



                <div className={styles.text}>
                    <h1>Mathematiklehrkraft (m/w/d)</h1>
                    <p>Zur Verstärkung unseres Teams suchen wir für das neue Schuljahr eine Mathematiklehrkraft für die 5.-10. Klasse des IGS-Zweigs.
                    </p>
                    <p>Anforderungen:</p>
                    <lu>
                        <li> 2. Staatsexamen im Lehramt für Mathematik und ein weiteres Fach ODER 1. Staatsexamen mit einigen Jahren Berufserfahrung </li>
                        <li> mindestens C1-Niveau des gemeinsamen Europäischen Referenzrahmens für die deutsche Sprache</li>
                        <li>aktive und selbstständige Arbeitsweise</li>
                        <li>EDV-Kenntnisse (insbesondere Microsoft Word, Excel, Powerpoint)</li>
                        <li>erweitertes Führungszeugnis ohne Einträge</li>
                    </lu>
                    <p> Wir bieten:</p>
                    <lu>
                        <li>ein sehr interkulturelles Umfeld </li>
                        <li>hohes Maß an Eigenverantwortung</li>
                        <li>unbefristete Stelle</li>
                        <li>attraktive Vergütung</li>
                        <li>Jobticket und Arbeitsendgeräte</li>

                    </lu>
                    <p>Anfragen und Bewerbungen mit eingescannten Zeugniskopien, Lebenslauf, und Kontaktadresse per E-Mail bitte an&nbsp;
                        <a href="mailto:i.oezkan@ese-frankfurt.de">i.oezkan@ese-frankfurt.de</a>!</p>
                </div>



            </section>
        </main>
         */}
            </>
    )

}

export default Stellenangebote;